<template>
  <header class="ln-hero">
    <div class="ln-hero__cover" :class="'ln-hero__cover--' + classNameCover">
      <router-link to="#" class="ln-hero__cover-logo">
        <mq-layout :mq="['m480', 'm576', 'm768']">
          <img v-show="logoStyle == 'dark'" src="../../../assets/img/logos/logo-hellobb-dark.svg" alt="" />
          <img v-show="logoStyle == 'white'" src="../../../assets/img/logos/logo-hellobb-white.png" alt="" />
        </mq-layout>
        <mq-layout mq="m1200">
          <img src="../../../assets/img/logos/logo-hellobb-dark.svg" alt="" />
        </mq-layout>
      </router-link>
      <picture class="ln-hero__inset" :class="{'ln-hero__inset--vertical': coverIsVertical}">
        <slot name="cover"></slot>
      </picture>
    </div>
    <aside class="ln-hero__col scrollto">
      <section class="ln-hero-form">
        <div class="ln-hero-form__logo">
          <img src="../../../assets/img/logos/logo-hellobb-dark.svg" alt="" />
        </div>
        <h1 class="ln-hero-form__title">{{ title }}</h1>
        <h2 class="ln-hero-form__subtitle" v-if="subtitle">
          {{ subtitle }}
        </h2>
        <!-- diferenciació formulari desktop i responsive (en dos pasos) -->
        <!-- <mq-layout :mq="['m480', 'm576', 'm768']">
        <div class="ln-hero-form__form">
          <InputText
            v-model="email"
            :errorLabel="emailError"
            :placeholder="$t('landings.hero.yourmailplaceholder', lang)"
            @focus="emailError = ''"
          />
        </div>
        <div class="ln-hero-form__actions">
          <bbButton
            class="button--accent button--block"
            :label="buttonText"
            @click="goToSignupSecondStep"
            :loading="loading"
          >
          </bbButton>
        </div>
        <login-social
          :show="true"
          :showFacebook="false"
          :showLabel="false"
          class="login-box__social"
          color="yellow"
          size="large"
          :origin="origin"
          :forcedLang="lang"
          :listType="listType"
        ></login-social>
        </mq-layout>
        <mq-layout mq="m1200">
          <div class="ln-hero-form__form">
          <InputText
            :label="$t('landings.hero.yourname', lang)"
            v-model="username"
            :errorLabel="usernameError"
            :placeholder="$t('landings.hero.yournameplaceholder', lang)"
            @focus="usernameError = ''"
          />
          <InputText
            :label="$t('landings.hero.yourmail', lang)"
            v-model="email"
            :errorLabel="emailError"
            :placeholder="$t('landings.hero.yourmailplaceholder', lang)"
            @focus="emailError = ''"
          />
          <InputText
            :label="$t('landings.hero.yourpassword', lang)"
            v-model="password"
            type="password"
            :errorLabel="passwordError"
            :placeholder="$t('landings.hero.yourpasswordplaceholder', lang)"
            @focus="passwordError = ''"
          />
          <div class="ln-hero-form__aceptance">
            <label for="aceptance" class="bb-form-checkbox">
              <input
                type="checkbox"
                id="aceptance"
                v-model="privacity"
                required
                @change="privacityError = ''"
              />
              <span v-html="$t('landings.hero.terms', lang)">
              </span>
            </label>
          </div>
          <div v-if="privacityError" class="bb-form-error">
            {{ privacityError }}
          </div>
        </div>
        <div class="ln-hero-form__actions">
          <bbButton
            class="button--accent button--block"
            :label="buttonText"
            @click="signUp"
            :loading="loading"
          >
          </bbButton>
        </div>
        <login-social
          :show="true"
          :showFacebook="false"
          :showLabel="true"
          class="login-box__social"
          color="yellow"
          size="large"
          :origin="origin"
          :forcedLang="lang"
          :listType="listType"
        ></login-social>
        </mq-layout> -->
        <!-- END: diferenciació formulari desktop i responsive (en dos pasos) -->
        <div class="ln-hero-form__form">
          <InputText
            :label="$t('landings.hero.yourname', lang)"
            v-model="username"
            :errorLabel="usernameError"
            :placeholder="$t('landings.hero.yournameplaceholder', lang)"
            @focus="usernameError = ''"
          />
          <InputText
            :label="$t('landings.hero.yourmail', lang)"
            v-model="email"
            :errorLabel="emailError"
            :placeholder="$t('landings.hero.yourmailplaceholder', lang)"
            @focus="emailError = ''"
          />
          <InputText
            :label="$t('landings.hero.yourpassword', lang)"
            v-model="password"
            type="password"
            :errorLabel="passwordError"
            :placeholder="$t('landings.hero.yourpasswordplaceholder', lang)"
            @focus="passwordError = ''"
          />
          <div class="ln-hero-form__aceptance">
            <label class="w-checkbox checkbox-field">
              <label style="display: inline;">
                {{ $t("signup.acceptTCpart1ImplicitVersion", lang) }}
                <router-link :to="$t('routes.confidentialityPolicy', lang)" style="text-decoration: underline;" target="_blank"
                >{{ $t("signup.acceptTCpart2", lang) }}
                </router-link
                >
                .
              </label>
            </label>
          </div>
        </div>
        <div class="ln-hero-form__actions">
          <bbButton
            class="button--accent button--block"
            :label="buttonText"
            @click="signUp"
            :loading="loading"
          >
          </bbButton>
        </div>
        <login-social
          :show="true"
          :showFacebook="false"
          :showLabel="true"
          class="login-box__social"
          color="yellow"
          size="large"
          :origin="origin"
          :forcedLang="lang"
          :listType="listType"
          :verticalAlign="true"
          :promoCode="promoCode"
        ></login-social>
      </section>
    </aside>
  </header>
</template>

<script>
import LoginSocial from "../../../components/ui/login/LoginSocial.vue";
import InputText from "../../../components/forms/InputText.vue";
import bbButton from "../../../components/buttons/bbButton.vue";
import axios from "axios";

const crypto = require("crypto");
import loginMixin from "../../mixins/login.js";

export default {
  name: "LandingHero",
  mixins: [loginMixin],
  components: {
    LoginSocial,
    InputText,
    bbButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      default: "Empieza tu lista ahora",
    },
    subtitle: {
      type: String,
      required: false,
    },
    origin: {
      type: String,
      required: true,
    },
    showLoginSocial: {
      type: Boolean,
      default: false,
    },
    classNameCover: String,
    coverIsVertical: {
      type: Boolean,
      default: false
    },
    lang: {
      type: String,
      default: "es-ES",
    },
    listType: {
      type: String,
      default: "baby-registry"
    },
    logoStyle: {
      type: String,
      default: "dark",
    },
    promoCode: {
      type: String,
      default: "",
    }
  },
  computed: {
    isFormValid() {
      return (
        this.username &&
        this.email &&
        this.password &&
        //this.privacity &&
        this.validateEmail()
      );
    },
  },
  data() {
    return {
      username: "",
      email: "",
      password: "",
      privacity: false,
      loading: false,
      emailError: "",
      usernameError: "",
      passwordError: "",
      privacityError: "",
    };
  },
  methods: {
    async goToSignupSecondStep() {
      //cleanr spaces (trim) and check email format
      this.email = this.email.trim();
      if (!this.validateEmail()) {
        this.emailError = this.$t("landings.hero.emailisnotvalid", this.lang);
        return;
      }
      
      this.loading = true;
      this.resetErrors();

      this.$router.push({
        name: "signup-landing",
        query: {
          email: this.email,
          backUrl: this.$route.path,
          origin: this.origin,
          listType: this.listType,
        },
      });

      return;
    },
    async signUp() {
      this.email = this.email.trim();
      this.loading = true;
      this.resetErrors();

      if (!this.username || !this.email || !this.password || !this.privacity) {
        if (!this.username) this.usernameError = this.$t("landings.hero.nameisneeded", this.lang);
        if (!this.email) this.emailError = this.$t("landings.hero.emailisneeded", this.lang);
        if (!this.password) this.passwordError = this.$t("landings.hero.passwordisneeded", this.lang);
        //if (!this.privacity)
        //  this.privacityError = this.$t("landings.hero.termsareneeded", this.lang);
        //this.loading = false;
        //return;
      }

      if (!this.validateEmail()) {
        this.email = this.email.trim();
        this.emailError = this.$t("landings.hero.emailisnotvalid", this.lang);
        this.loading = false;
      }

      if (!this.isFormValid) {
        return;
      }

      //get referral url
      let source_url = ''
      try {
        source_url = localStorage.getItem('source_url');
      }
      catch (e) {
        console.log(e);
      }

      const baseURL = process.env.API;
      try {
        const response = await axios.post(`${baseURL}/user/signup`, {
          name: this.username,
          email: this.email,
          password: this.password,
          SignupOrigin: this.origin,
          listType: this.listType,
          referralUrl: source_url,
          language: this.lang,
          promoCode: this.promoCode
        });

        this.setModalShownCookie();
      } catch (error) {
        if (parseInt(error.response?.status) === 409) {
          this.loading = false;

          this.error = "Este email ya ha sido registrado. ¿Quieres iniciar sesión?";
          await this.$sleep(this.goToLogin, 2000);

          return;
        }
      }

      window.mixpanel.people.set("Signup Origin", this.origin);
      this.$root.trackConversion({
        email: this.email,
      })

      if(this.listType == "wishlist") return this.login(`/onboarding-0?newuser=true`);
      else return this.login(`/onboarding/${encodeURIComponent(this.listType)}`);
    },
    validateEmail() {
      const email = this.email.toLowerCase();
      const parts = email.split("@");
      if (parts.length !== 2) {
        return false;
      }

      const [left, right] = parts;

      return (
        left.match(/^\w+([.-_+]\w+)*$/) &&
        right.match(/^\w+([.-]\w+)*\.\w{2,10}$/)
      );
    },
    setModalShownCookie() {
      const days = 30;
      const expirationDate = new Date();
      expirationDate.setDate(expirationDate.getDate() + days);

      const currentTimestamp = new Date().getTime().toString();
      const randomValue = Math.random().toString();
      const uniqueHash = crypto
        .createHash("sha256")
        .update(currentTimestamp + randomValue)
        .digest("hex");

      document.cookie = `modalShown=${uniqueHash}; expires=${expirationDate.toUTCString()}; path=/`;

      // Acceder a la cookie y mostrar su valor en la consola
      const cookieValue = document.cookie.replace(
        /(?:(?:^|.*;\s*)modalShown\s*=\s*([^;]*).*$)|^.*$/,
        "$1"
      );
    },
    async goToLogin() {
      await this.$router.push({ name: "login" });
    },
    resetErrors() {
      this.usernameError = "";
      this.emailError = "";
      this.passwordError = "";
      this.privacityError = "";
    },
  },
};
</script>

<style scoped>
.landing-vertical-cover {
  /* display: flex;
  flex-direction: row;
  width: 100%; */
}
.landing-header {
  background-color: #ffc944;  
}
.landing-logo {
  display:none;
}
.landing-logo img {
  
}
@media screen and (max-width: 768px) {
  .landing-header {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    background-color: #ffc944;
  }
  .landing-logo {
    display: flex;
    width: 100%;
    padding-left: 1rem;
    padding-top: 1rem;
  }
  .landing-logo img {
    width: 120px;
  }
}

</style>
